<script>
import {mapActions, mapState} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import OrganisationListItem from "@/components/MainSearch/SearchResult/OrganisationListItem.vue";
import InfiniteLoadingLoader from "@/components/InfiniteLoadingLoader.vue";
import BaseNoResultMessage from "@/components/BaseNoResultMessage.vue";

export default {
  name: "OrganisationList",
  components: {
    OrganisationListItem,
    InfiniteLoadingLoader,
    BaseNoResultMessage
  },
  computed: {
    ...mapState(mainSearchStore, [
      'searchParams',
      'searchResult'
    ]),
    hasResults() {
      return this.searchResult.length > 0;
    }
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'runSearch',
      'updateSearchParams'
    ]),
    processSearch($state) {
      if (!this.searchParams.last) {
        this.runSearch().then(()=> {
          this.updateSearchParams('page', this.searchParams.page + 1);
          $state.loaded();
        });
      } else {
        $state.complete();
      }
    },
    infiniteHandler($state) {
      if ($state) {
        this.processSearch($state);
      }
    }
  },
  beforeMount() {
    this.runSearch(true, true).then(()=> {
      this.updateSearchParams('page', this.searchParams.page + 1);
    });
  }
}
</script>

<template>
  <div>
    <template v-if="hasResults">
      <organisation-list-item v-for="item in searchResult"
                              :key="item.id"
                              :item-data="item"
      />
      <infinite-loading @infinite="infiniteHandler">
        <template #spinner>
          <InfiniteLoadingLoader/>
        </template>
        <template #no-results>
         <div></div>
        </template>
      </infinite-loading>
    </template>
    <template v-else>
      <base-no-result-message :text="$t('common.noResults')"/>
    </template>
  </div>
</template>